import './BlueCardInfoCard.css';
import { SlCalender } from "react-icons/sl";
import { MdOutlineTimer } from "react-icons/md";
import { BiDrink } from "react-icons/bi";
import { HiUsers } from "react-icons/hi";

const BlueCardInfoCard = ({ orderData }) => {
    return (
        <div className="pslis-info-card">
            <div className="pslis-info-row">
                <div className="pslis-info-label">
                    <SlCalender /> Party Date :
                </div>
                <div className="pslis-info-value">{orderData?.party_date}</div>
            </div>

            <div className="pslis-info-row">
                <div className="pslis-info-label">
                    <MdOutlineTimer /> Party Time slot :
                </div>
                <div className="pslis-info-value">{orderData?.party_time}</div>
            </div>

            <div className="pslis-info-row">
                <div className="pslis-info-label">
                    <BiDrink /> Package Type :
                </div>
                {orderData?.title ? (
                    <div className="pslis-info-value">
                        {orderData.title.length > 18
                            ? orderData.title.slice(0, 18) + "..."
                            : orderData.title}
                    </div>
                ) : (
                    <div className="pslis-info-value">
                        {orderData?.package_title_name?.length > 18
                            ? orderData.package_title_name.slice(0, 18) + "..."
                            : orderData?.package_title_name}
                    </div>
                )}

            </div>

            <div className="pslis-info-row">
                <div className="pslis-info-label">
                    <HiUsers /> Pax :
                </div>
                <div className="pslis-info-value">
                    {orderData?.male_qty ? (
                        <>
                            {Number(orderData?.male_qty || 0) + Number(orderData?.female_qty || 0)}
                        </>
                    ) : (
                        <>
                            {Number(orderData?.male || 0) + Number(orderData?.female || 0)}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BlueCardInfoCard;
